// extracted by mini-css-extract-plugin
export default {"inputContainer":"DealParcelsInput_inputContainer__IzRlF","parcelRow":"DealParcelsInput_parcelRow__P7wev"};